<template>
    <div class="slide trivia-19">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="5"
                    :total="5"
                    :selectAll=true
                    :className="className" />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "yarnboard-3",
            className: "trivia-19",
            currentTrivia: 19,
            questions: {
                question: {
                    "title": "Which of the following could be interview questions?",
                    "answers": [
                        {"key": "A", "answer": "What were you planning on doing with the merchandise?"},
                        {"key": "B", "answer": "What were you hoping to buy with the money you made after selling the merchandise?"},
                        {"key": "C", "answer": "How did you learn to steal in the manner that you tried today?"},
                        {"key": "D", "answer": "How did you get to the store today?"}
                    ],
                    "correctAnswer": ["A", "B", "C", "D"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss">
.trivia-19 {

    h1{
        line-height: 1.2;
    }
}
</style>
